import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { Box, Typography } from '@mui/material';
import * as E from 'fp-ts/Either';
import { useEffect, useReducer } from 'react';
import { Tweet } from 'react-twitter-widgets';
import StageLayout from '../stage-layout';
import TwitterButton from '../twitter-button';
import { tweetIncludesContent, TwitterInput } from '../twitter-post';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var twitterReplyReducer = function twitterReplyReducer(state, action) {
  switch (action.type) {
    case 'tweetReply':
      return _objectSpread(_objectSpread({}, state), {}, {
        tweetReply: action.reply
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.error
      });

    default:
      return state;
  }
};

var TwitterReply = function TwitterReply(_ref) {
  var _twitterAccount$authU;

  var stage = _ref.stage,
      activity = _ref.activity,
      completeStage = _ref.completeStage,
      twitterAccount = _ref.twitterAccount,
      completeStageStatus = _ref.completeStageStatus,
      isPreview = _ref.isPreview,
      prospect = _ref.prospect;
  var completionText = stage.completionText,
      defaultText = stage.defaultText,
      requiredContent = stage.requiredContent;

  var _useReducer = useReducer(twitterReplyReducer, {
    tweetReply: defaultText !== null && defaultText !== void 0 ? defaultText : '',
    error: false
  }),
      _useReducer$ = _useReducer[0],
      tweetReply = _useReducer$.tweetReply,
      error = _useReducer$.error,
      dispatch = _useReducer[1];

  useEffect(function () {
    var _stage$defaultText;

    return dispatch({
      type: 'tweetReply',
      reply: (_stage$defaultText = stage.defaultText) !== null && _stage$defaultText !== void 0 ? _stage$defaultText : ''
    });
  }, [stage.id]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsxs(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(Box, {
      children: twitterAccount && /*#__PURE__*/_jsx(TwitterButton, {
        connected: twitterAccount.connected,
        authUrl: (_twitterAccount$authU = twitterAccount === null || twitterAccount === void 0 ? void 0 : twitterAccount.authUrl) !== null && _twitterAccount$authU !== void 0 ? _twitterAccount$authU : '',
        status: mutationValue,
        defaultText: completionText || 'Reply to tweet',
        savingText: "Replying...",
        completedText: "Replied",
        onClick: function onClick() {
          return !requiredContent || tweetIncludesContent(tweetReply, requiredContent) ? completeStage({
            twitterPostInput: {
              stageID: stage.id,
              activityID: activity === null || activity === void 0 ? void 0 : activity.id,
              tweet: tweetReply
            }
          }) : dispatch({
            type: 'error',
            error: true
          });
        },
        isPreview: isPreview
      })
    }),
    "data-element": "StageLayout",
    "data-component": "TwitterReply",
    "data-source-file": "index.tsx",
    children: [stage.twitterPostId && /*#__PURE__*/_jsx(Tweet, {
      tweetId: stage.twitterPostId,
      renderError: function renderError() {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            minWidth: 200,
            maxWidth: 500,
            height: 200,
            background: function background(t) {
              return t.palette.secondary.background;
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: function borderRadius(t) {
              return t.shape.borderRadius;
            },
            mb: 2
          },
          children: /*#__PURE__*/_jsx(Typography, {
            children: "Could not load tweet"
          })
        });
      }
    }), /*#__PURE__*/_jsx(Typography, {
      sx: {
        mt: 2
      },
      variant: "h5",
      "data-element": "Typography",
      "data-component": "TwitterReply",
      "data-source-file": "index.tsx",
      children: "Reply to tweet"
    }), /*#__PURE__*/_jsx(TwitterInput, {
      tweet: tweetReply,
      error: error,
      requiredContent: requiredContent,
      handleChange: function handleChange(newValue) {
        dispatch({
          type: 'tweetReply',
          reply: newValue
        });
        dispatch({
          type: 'error',
          error: false
        });
      },
      "data-element": "TwitterInput",
      "data-source-file": "index.tsx"
    })]
  });
};

export default TwitterReply;